/* BASIQ · Producto — galería + sticky + variantes (v5 · arrastre con ratón) */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var REDUCED = false;
  var SMOOTH = REDUCED ? 'auto' : 'smooth';

  function replay(el, cls) {
    if (!el || REDUCED) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

  /* ---------- Sticky inteligente de la columna izquierda ---------- */
  function setupSticky(root) {
    var el = root.querySelector('.bp__media-sticky');
    if (!el) return;

    function update() {
      if (!DESKTOP.matches) {
        el.style.top = '';
        return;
      }
      var offset = parseInt(getComputedStyle(root).getPropertyValue('--bp-sticky'), 10);
      if (isNaN(offset)) offset = 112;
      var top = Math.min(offset, window.innerHeight - el.offsetHeight - 24);
      el.style.top = top + 'px';
    }

    update();
    window.addEventListener('resize', update);
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(el);
    window.addEventListener('load', update);
  }

  /* ---------- Arrastre con ratón para filas deslizables ---------- */
  function dragScroll(el, onRelease) {
    var down = false, moved = false, startX = 0, startLeft = 0;

    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = el.scrollLeft;
    });

    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        el.classList.add('is-dragging');
      }
      if (moved) {
        el.scrollLeft = startLeft - dx;
        e.preventDefault();
      }
    });

    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (!moved) return;
      el.classList.remove('is-dragging');
      if (onRelease) onRelease();
      setTimeout(function () { moved = false; }, 0);
    });

    /* Si ha habido arrastre, no cuenta como clic (miniaturas) */
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* ---------- Galería: miniaturas + swipe ---------- */
  function setupGallery(root) {
    var track = root.querySelector('[data-bp-track]');
    var row = root.querySelector('[data-bp-thumbs]');
    if (!track) return;
    var thumbs = row ? Array.prototype.slice.call(row.querySelectorAll('[data-bp-thumb]')) : [];
    var last = 0;

    function setActive(i) {
      last = i;
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      var a = thumbs[i];
      if (a && row) {
        row.scrollTo({
          left: a.offsetLeft - row.clientWidth / 2 + a.clientWidth / 2,
          behavior: SMOOTH
        });
      }
    }

    function goTo(i, instant) {
      track.scrollTo({ left: track.clientWidth * i, behavior: instant ? 'auto' : SMOOTH });
      setActive(i);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.getAttribute('data-bp-thumb'), 10) || 0);
      });
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i !== last) setActive(i);
      });
    }, { passive: true });

    /* Arrastrar con el ratón (en táctil ya se desliza de forma nativa) */
    dragScroll(track, function () {
      goTo(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
    });
    if (row) dragScroll(row, null);

    /* Expuesto para el selector de variantes */
    root._bpGoToMedia = function (mediaId, instant) {
      var slide = track.querySelector('[data-media-id="' + mediaId + '"]');
      if (!slide) return;
      goTo(parseInt(slide.getAttribute('data-bp-slide'), 10) || 0, instant);
    };
  }

  /* ---------- Precio ---------- */
  function updatePrice(root, v, animate) {
    var wrap = root.querySelector('[data-bp-price]');
    if (!wrap) return;
    var cur = wrap.querySelector('[data-bp-price-current]');
    var cmp = wrap.querySelector('[data-bp-price-compare]');
    var badge = wrap.querySelector('[data-bp-price-badge]');

    if (cur) cur.textContent = v.price;
    if (cmp) {
      if (v.compare) {
        cmp.textContent = v.compare;
        cmp.hidden = false;
      } else {
        cmp.hidden = true;
      }
    }
    if (badge) {
      if (v.pct > 0) {
        badge.textContent = (badge.getAttribute('data-format') || '-[percent]%').replace('[percent]', v.pct);
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }
    if (animate) replay(wrap, 'is-updating');
  }

  /* ---------- Selector de variantes ---------- */
  function setupPicker(root) {
    var picker = root.querySelector('[data-bp-picker]');
    var dataEl = root.querySelector('[data-bp-variants]');
    if (!picker || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var groups = Array.prototype.slice.call(picker.querySelectorAll('[data-bp-option]'));
    var idInput = root.querySelector('[data-bp-variant-input]');

    function matches(v, opts) {
      for (var i = 0; i < opts.length; i++) {
        if (v.options[i] !== opts[i]) return false;
      }
      return true;
    }
    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i], opts)) return variants[i];
      }
      return null;
    }
    function currentOpts() {
      return groups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    /* Si la combinación no existe, busca la más parecida (priorizando disponibles) */
    function resolve(opts, idx) {
      var exact = find(opts);
      if (exact) return exact;
      var best = null;
      var bestScore = -1;
      variants.forEach(function (v) {
        if (v.options[idx] !== opts[idx]) return;
        var s = v.available ? 100 : 0;
        for (var i = 0; i < opts.length; i++) {
          if (v.options[i] === opts[i]) s++;
        }
        if (s > bestScore) {
          best = v;
          bestScore = s;
        }
      });
      return best || variants[0];
    }

    function paint(v, animate) {
      groups.forEach(function (g, gi) {
        Array.prototype.forEach.call(g.querySelectorAll('input[type="radio"]'), function (inp) {
          var label = inp.closest('.bp-vp__item');
          if (!label) return;
          var on = inp.value === v.options[gi];
          var wasOn = label.classList.contains('is-selected');
          inp.checked = on;
          label.classList.toggle('is-selected', on);
          if (on && !wasOn && animate) replay(label, 'is-pop');

          var test = v.options.slice();
          test[gi] = inp.value;
          var tv = find(test);
          label.classList.toggle('is-missing', !tv);
          label.classList.toggle('is-unavailable', !!tv && !tv.available);
        });

        var out = g.querySelector('[data-bp-option-value]');
        if (out && out.textContent !== v.options[gi]) {
          out.textContent = v.options[gi];
          if (animate) replay(out, 'is-swap');
        }
      });
    }

    function apply(v, animate) {
      paint(v, animate);
      if (idInput) idInput.value = v.id;
      updatePrice(root, v, animate);
      if (v.media && root._bpGoToMedia) root._bpGoToMedia(v.media, !animate);

      if (animate) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
      }

      root.dataset.variantId = v.id;
      root.dataset.variantAvailable = v.available ? 'true' : 'false';
      root.dispatchEvent(new CustomEvent('bp:variant-change', {
        bubbles: true,
        detail: { variant: v }
      }));
    }

    picker.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      var idx = groups.indexOf(t.closest('[data-bp-option]'));
      if (idx < 0) return;
      apply(resolve(currentOpts(), idx), true);
    });

    apply(find(currentOpts()) || variants[0], false);
  }

  /* ---------- Init ---------- */
  function init(root) {
    if (!root || root.dataset.bpReady === '1') return;
    root.dataset.bpReady = '1';
    setupGallery(root);
    setupSticky(root);
    setupPicker(root);
  }

  function initAll() {
    document.querySelectorAll('[data-bp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-bp]'));
  });
})();